import FilterableMultiSelector from '../../../../../components/selector/FilterableMultiSelector';
import './SearchDistrictAction.scss';
import { usePrepareData } from './SearchDistrictActionHooks';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onFilterChange: () => {},
  filterValue: null,
  isMultiple: false,
  className: '',
  popperClassName: '',
  disabled: false,
  ableToUnselectedInSingleMode: false,
};
const SearchDistrictAction = (props) => {
  const { onFilterChange, filterValue, isMultiple, className, popperClassName, disabled, ableToUnselectedInSingleMode } = { ...defaultProps, ...filterUndefined(props) };
  const {
    transformDistricts,
    loading,
  } = usePrepareData();

  const handleMultiSelectorApply = (value) => {
    if (value && filterValue && value.key === filterValue) {
      return;
    }
    onFilterChange(value);
  };

  return (
    <FilterableMultiSelector
      popperClassName={popperClassName}
      className={`search-district-action ${className}`}
      key='filter-selector-district'
      onApply={(value) => {
        handleMultiSelectorApply(value);
      }}
      label='Please select district'
      initFilterKeyValues={
        Array.isArray(filterValue) ? filterValue : filterValue && [filterValue]
      }
      options={transformDistricts}
      filterable
      isMultiple={isMultiple}
      subTitle='Filter District'
      disabled={disabled || transformDistricts.length <= 1}
      loading={loading}
      ableToUnselectedInSingleMode={ableToUnselectedInSingleMode}
    />
  );
};

export default SearchDistrictAction;
